import { Component, inject, OnInit } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { RouterModule } from '@angular/router'
import { HeaderComponent } from './header/header.components'
import { AuthDirective, LayoutActions } from '@monorepo-channels/channels/domain'
import { ConciergeService } from './header/concierge.service'
import { MatSidenavModule } from '@angular/material/sidenav'
import { Store } from '@ngrx/store'
import { BreakpointObserver } from '@angular/cdk/layout'

@Component({
	standalone: true,
	imports: [RouterModule, MatIconModule, HeaderComponent, MatSidenavModule],
	selector: 'pm-root',
	template: `
		@if (conciergeService.isLogged()) {
			<router-outlet></router-outlet>
		} @else {
			<pm-header></pm-header>
		}
	`,
	styles: '',
	hostDirectives: [AuthDirective],
})
export class AppComponent implements OnInit {
	private store = inject(Store)
	public conciergeService = inject(ConciergeService)
	private breakpointObserver = inject(BreakpointObserver)

	ngOnInit(): void {
		this.breakpointObserver
			.observe(['(max-width: 768px)'])
			.subscribe(breakpointState =>
				this.store.dispatch(LayoutActions.changeLayout({ breakpointState }))
			)
	}
}
